<template>
  <div
    tabindex="-1"
    role="dialog"
    class="modal-side-drawer-filters fade fixed-end op"
  >
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Advanced Search</h2>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true"><i class="far fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body" v-if="__initialized">
          <div class="data-filters">
            <div class="row">
              <div class="col-12 col-lg-8">
                <label>Search</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-search"></i>
                  </span>
                  <input type="text" class="form-control" :placeholder="placeholder" :value="filters.search" @input="updateSearch"/>
                </div>
              </div>

              <div class="col-12 col-lg-4">
                <label>Sort</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-sort-amount-down"></i>
                  </span>

                  <multiselect
                    :options="sortByOptions"
                    :show-labels="false"
                    :allow-empty="false"
                    placeholder
                    v-model="sortBy"
                    label="name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'

// Search + A-Z sort filters, shared by the applications and clusters lists
export default {
  mixins: [useQueryParamFilters()],

  props: {
    placeholder: {
      type: String,
      default: 'Find application by name'
    }
  },

  data () {
    return {
      filters: {
        search: null,
        sort: 'asc'
      },
      sortByOptions: [
        { name: 'A-Z', key: 'asc' },
        { name: 'Z-A', key: 'desc' }
      ]
    }
  },

  computed: {
    sortBy: {
      get () {
        return this.sortByOptions.find(({ key }) => key === this.filters.sort)
      },

      set (value) {
        this.filters.sort = value.key
      }
    }
  },

  methods: {
    updateSearch: debounce(function (event) {
      this.filters.search = event.target.value
    }, 750)
  },

  watch: {
    queryParams: {
      handler (params) {
        this.$emit('input', params)
      },
      immediate: true
    }
  }
}
</script>
